import { useState, useMemo, useRef, useEffect } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function useAuthState() {
  const [token, setToken] = useState(() => localStorage.getItem("atelier_token"));
  const [user, setUser] = useState(() => {
    const saved = localStorage.getItem("atelier_user");
    return saved ? JSON.parse(saved) : null;
  });

  const logoutRef = useRef(null);

  const client = useMemo(() => {
    const instance = axios.create({ baseURL: API });
    instance.interceptors.request.use((config) => {
      if (token) config.headers.Authorization = `Bearer ${token}`;
      return config;
    });
    instance.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response?.status === 401 && logoutRef.current) {
          logoutRef.current();
        }
        return Promise.reject(error);
      }
    );
    return instance;
  }, [token]);

  const saveSession = (payload) => {
    localStorage.setItem("atelier_token", payload.token);
    localStorage.setItem("atelier_user", JSON.stringify(payload.user));
    setToken(payload.token);
    setUser(payload.user);
  };

  const logout = () => {
    localStorage.removeItem("atelier_token");
    localStorage.removeItem("atelier_user");
    setToken(null);
    setUser(null);
  };

  useEffect(() => { logoutRef.current = logout; });

  return { token, user, client, saveSession, logout };
}
